module.exports = __webpack_public_path__ + "img/SSRLogo.98f56bac.svg";